(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-trust-info"] && !Shopify.designMode) return;
  try {
    class SteadyViewers extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-viewer-count]');
      this.base = Number(this.dataset.base) || 9;
      this.minimum = Math.max(3, this.base - 2);
      this.maximum = this.base + 2;
      this.storageKey = `yeisi-viewers-${this.dataset.productId}`;
      this.value = this.readValue();
      this.render();
      this.timer = window.setInterval(() => this.update(), 45000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    readValue() {
      try {
        const saved = JSON.parse(window.localStorage.getItem(this.storageKey));
        if (saved && Date.now() - saved.time < 30 * 60 * 1000) {
          return Math.min(this.maximum, Math.max(this.minimum, Number(saved.value)));
        }
      } catch (error) {
        // Storage can be unavailable in private browsing.
      }
      return this.base;
    }

    update() {
      const movement = Math.random() < 0.5 ? -1 : 1;
      this.value = Math.min(this.maximum, Math.max(this.minimum, this.value + movement));
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify({ value: this.value, time: Date.now() }));
      } catch (error) {
        // The counter can continue without persistence.
      }
      this.render();
    }

    render() {
      if (this.output) this.output.textContent = String(this.value);
    }
  }

  if (!customElements.get('steady-viewers')) {
    customElements.define('steady-viewers', SteadyViewers);
  }
  } catch(e) { console.error(e); }
})();

})();
